import editable from "@/domain/decorators/editable";

export default class PurchasedItem extends editable {
    purchasedItemID = 0;
    productBomID!: number;
    piNumber!: string;
    piDescription!: string;
    piSubProposal!: boolean;
    piVendor!: string;
    piCostQty1!: number;
    piCostQty2!: number;
    piCostQty3!: number;
    piCostQty4!: number;
    piCostQty5!: number;
    quoteAttached!: boolean;
    piReferenceNumber!: string;
    proposalReferenceNumber!: number;
    piOperationUOfM!: string;
    piWeight!: number;
    piLineNumber!: number;
    productBomLineNumber!: number; //From productBom
    piQuantity!: number; //From productBom
    allPlantsMaterialHold!: string;
    allPlantsMaterialHoldSeverityCSS!: string;
    allPlantsMaterialHoldDescription!: string;
    plantSpecificMaterialHold!: string;
    plantSpecificMaterialHoldSeverityCSS!: string;
    plantSpecificMaterialHoldDescription!: string;
    piOverrideCost!: boolean;
    piComment!: string;

    constructor(init?: Partial<PurchasedItem>) {
        super()
        Object.assign(this, init)
    }

    public compareTo(val: PurchasedItem): number {
        return this.productBomLineNumber > val.productBomLineNumber ? 1 :
            this.productBomLineNumber === val.productBomLineNumber ? 0 :
                -1;
    }

}
